/**
 * Created by Pali on 26/10/23.
 */

angular.module("screensApp")

  .controller("BiometryController", function ($scope, $rootScope, BiometryService, AutoCaptureService, VerificationService, CameraHealthCheckService) {
    var instructionChangeEvent = "face-auto-capture:instruction-changed";
    $scope.appearanceVersion = $rootScope.config.BiometryAppearanceVersion;
    
    // povolené hodnoty lebo v DB môže mať stroj NULL, napr. pri: terminovat stroj a spustit na novo (zmena prevadzkara)
    const allowedBiometryAppearanceVersion = [
      "CameraInCircle", // nie je na prevadzkach
      "CameraInCircleTransparent", // nie je na prevadzkach
      "CameraInCircleWhite", // nie je na prevadzkach
      "CameraInCircleHints", // je na prevadzkach cca 95 strojov a je to fallback (kamera v strede)
      "CameraInCircleLeft", // nie je na prevadzkach
      "CameraInCircleRight" // je na prevadzkach vacsinou
    ];
    // kontroluje ci je hodnota z DB v povolenom zozname, ak nie nastav fallback
    if (!allowedBiometryAppearanceVersion.includes($scope.appearanceVersion)) {
      $scope.appearanceVersion = "CameraInCircleHints"; // fallback
    }      

    // Definovanie handleInstructionChange raz, aby referencia bola stabilna
    $scope.handleInstructionChange = function(event) {
      $scope.lastInstructionCode = event.detail.instructionCode;
      $scope.$apply();
    }

    // Priluchajuce css classes pre UI pri biometrii
    $rootScope.resolveAppearanceVersion = function() {
        switch($scope.appearanceVersion) {
          case "CameraInCircle":
            return "continuing";
          break;
          case "CameraInCircleTransparent":
            return "continuing-white transparent";
          break;
          case "CameraInCircleWhite":
            return "continuing-white";
          break;
          case "CameraInCircleRight":
            return "continuing-white continuing-right continuing-white-right hints ";
          break;
          case "CameraInCircleLeft":
            return "continuing-white continuing-left continuing-white-left hints ";
          break;
          case "CameraInCircleHints":
          default:
            return "continuing-white hints";
          break;
        }
    }

    // Show Biometry
    $rootScope.showBiometry = function (data) {
      $scope.biometryLang = $rootScope.config.LanguageId;
      $scope.state = data.state;
      // Nastavenie animacie progressbaru a skrytie hlasky "Selfie sa odosiela..."
      $scope.setSelfieCaptured(false);
      if ($scope.state === "continuing") {
        $rootScope.visualState = $rootScope.resolveAppearanceVersion();
        if (data && data.loginBtnTimeStamp) {
          // Save timestamp of login button
          BiometryService.setBiometryLoginBtnTimeStamp(data.loginBtnTimeStamp);
        }
        if (BiometryService.getBiometryPause()) {
          // Biometry again
          BiometryService.setBiometryCaptureCount(0);
          BiometryService.setBiometryPause(false);
          $scope.biometryLoginRfs();
          document.dispatchEvent(
            new CustomEvent("face-auto-capture:control", {
            detail: { instruction: "continue-detection" }
            })
          );
        }
      } else if (data.state === "failed" && data.info) {
        BiometryService.setBiometryLoginBtnTimeStamp(0);
        $rootScope.visualState = data.state + "-" + data.info;
      } else {
        // error state z onbording pre selfieFailed - zobrazujem inu hlasku 
        if (AutoCaptureService.isOnboardingInProgress()) {
          $scope.errorStateDocument = data?.errorKey || "";
        }
        $rootScope.visualState = data.state;
      }

      // Spustenie Camera Health Check servisu - za kazdych okolnosti lebo moze ostat zamrznuty aj obraz s tvarou a potom prihlasuje ineho hraca ako stoji pred kamerou
      CameraHealthCheckService.start(document.querySelector('x-dot-face-auto-capture video'));

      // Pridavanie listenera na zmenu instrukcie z api a pridanie do $scope pre class root elementu na stylovanie zobrazenia a pre preklady
      document.addEventListener(instructionChangeEvent, $scope.handleInstructionChange);

      $rootScope.settings.biometry.show = true;
      $rootScope.$$phase || $rootScope.$apply();
    };

    // Stop Biometry
    $rootScope.stopBiometry = function (destroy) {
      // Nastavenie animacie progressbaru a skrytie hlasky "Selfie sa odosiela..."
      $scope.setSelfieCaptured(false);
      BiometryService.setBiometryLoginBtnTimeStamp(0);
      BiometryService.clearBiometryTimeout();
      BiometryService.setBiometryCaptureCount(0);
      BiometryService.setBiometryPause(true);
      if (destroy) {
        // zastavujem Camera Health Check servis aby nekontroloval neexistujúci element a nevyhodnotil to ako chybu kamery
        CameraHealthCheckService.stop();
        document.querySelectorAll('x-dot-face-auto-capture, x-dot-face-auto-capture-ui')
          .forEach(el => el.remove());
      }
    };

    // Hide biometry right after stopping
    $rootScope.hideBiometry = function () {
      $rootScope.stopBiometry();
      $rootScope.visualState = "";
      $rootScope.settings.biometry.show = false;
      $rootScope.$$phase || $rootScope.$apply();
      $rootScope.BottomScreen("hideBiometryLogin", { initiator: "screensApp" });
      document.removeEventListener(instructionChangeEvent, $scope.handleInstructionChange);
    };

    $rootScope.biometryPhotoTakenCallBackResolver = function() {
      switch(AutoCaptureService.getAutoCaptureState()) {
        case AutoCaptureService.faceCaptureStates.biometry:
          // Vysledna fotka je odoslana do nativeApp ktora oreze 1/3 zlavej aj spravej strany a pouzije len strednu cast fotky pre rozpoznanie tvare, preto je potrebne poslat celu fotku a nie uz orezanu
          return biometryPhotoTaken;
          break;
        case AutoCaptureService.faceCaptureStates.selfie:
          // Vysledna fotka je odoslana do nativeApp bez orezania a pouzije sa cela fotka (Info od Lubosa Olejara - zrejme orezavanie robilo problem)
          return onboardingPhotoTaken;
          break;
        case AutoCaptureService.faceCaptureStates.privateAccess:
          // Vysledna fotka je odoslana do central-sportbox sluzby ktora oreze 1/3 zlavej aj spravej strany a pouzije len strednu cast fotky pre rozpoznanie tvare, preto je potrebne poslat celu fotku a nie uz orezanu
          return privateAccessPhotoTaken;
        default:
          console.log("biometryPhotoTakenCallBackResolver DEFAULT STATE" + AutoCaptureService.getAutoCaptureState());
          break;
      }
    }

    // Prepojenie aktualneho stavu snimania typu fotografie s html
    $rootScope.actualCaptureState = function() {
      return AutoCaptureService.getAutoCaptureState();
    }

    // Biometry on top functions
    $rootScope.biometryLoginOnTop = function () {
      if ($rootScope.config.BiometryLogin) {
        BiometryService.setBiometryCaptureCount(0);
        $rootScope.settings.biometry.show = true;
        $rootScope.$$phase || $rootScope.$apply();
        $scope.biometryLoginRfs();
        // Kontrolujem stavovu premennu ci nebezi onboarding lebo pri nom sa pouziva iny callback pre initBiometryCameraFirstTime
        if (AutoCaptureService.isOnboardingInProgress()) {
          // Biometry lib face recognition is initialized and paused
          $rootScope.biometryResolve({"state": "continuing"});
        } else if ($("x-dot-face-auto-capture").length) {
          // Nastavujem onComplete callback pre biometry login
          var faceElement = document.querySelector("x-dot-face-auto-capture");
          if (faceElement?.configuration) {
            faceElement.configuration.onComplete = $rootScope.biometryPhotoTakenCallBackResolver();
            // Nastavujem options pre biometry login
            faceElement.configuration.autoCapture.candidateSelectionDurationMillis = $rootScope.config.BiometryCandidateSelectionDuration;
          }
          // Biometry lib face recognition is initialized and paused
          $rootScope.biometryResolve({"state": "continuing"});
        } else {
          $rootScope.initBiometryCameraFirstTime($rootScope.biometryPhotoTakenCallBackResolver());
        }
      } else {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: biometryLoginOnTop() BiometryLogin: ' + $rootScope.config.BiometryLogin);
      }
    };

    // Posledny krok pri onboardingu - odfotenie tvare
    $rootScope.onboardingSelfie = function() {
      $rootScope.settings.biometry.show = true;
      if ($("x-dot-face-auto-capture").length) {
        // Odpauzovanie uz inicializovanej kniznice pre automaticku detekciu tvare
        try {
          $rootScope.stopBiometry();
          $rootScope.visualState = $rootScope.resolveAppearanceVersion();
          BiometryService.setBiometryCaptureCount(0);
          AutoCaptureService.setAutoCaptureState(AutoCaptureService.faceCaptureStates.selfie);
          BiometryService.setBiometryPause(false);
          $("#" + $scope.appearanceVersion).show();
          document.dispatchEvent(
            new CustomEvent("face-auto-capture:control", {
              detail: { instruction: "continue-detection" }
            })
          );
        } catch (error) {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: onboardingSelfie() error: ' + error.toString());
          $rootScope.createLog(2, 'onboardingSelfie()', '# ERROR: ' + error.toString());
        }
      } else {
        // Inicializacia kniznice pre automaticku detekciu tvare este neprebehla
        $rootScope.initBiometryCameraFirstTime(onboardingPhotoTaken);
      }
      // Nastavenie animacie progressbaru a skrytie hlasky "Selfie sa odosiela..."
      $scope.setSelfieCaptured(false);
    };

    // Inicializacia kniznice pre automaticku detekciu a odfotenie tvare
    $rootScope.initBiometryCameraFirstTime = function(photoTakenCallBack) {
      // Biometry lib face recognition starting first time
      // Odpauzuje biometrylogin
      BiometryService.setBiometryPause(false);
      var cam = document.createElement("x-dot-face-auto-capture");
      $("#" + $scope.appearanceVersion).empty().show().append(cam);
      $scope.biometryLoadFaceProps(photoTakenCallBack);
      if (["CameraInCircleHints", "CameraInCircleLeft", "CameraInCircleRight"].includes($scope.appearanceVersion)) {
        var ui = document.createElement("x-dot-face-auto-capture-ui");
        $("#" + $scope.appearanceVersion).append(ui);
        ui.configuration = {
          control: {
            showCameraButtons: false,
            showDetectionLayer: false
          },
          appStateInstructions: {
            loading: {
              visible: false
            },
            waiting: {
              visible: false
            }
          },
          instructions: $rootScope.translations.biometry[$scope.biometryLang]?.instructions || {},
          styling: {
            theme: {
              colors: {
                placeholderColor: "transparent"
              }
            }
          }
        };
      }
    };

    // Sledovanie zmeny jazyka pre biometriu
    $scope.$watch('biometryLang', function (newLang) {
      if (newLang) {
          var uiElement = document.querySelector("x-dot-face-auto-capture-ui");
          if (uiElement) {
            uiElement.configuration = {
              control: {
                showCameraButtons: false,
                showDetectionLayer: false
              },
              appStateInstructions: {
                loading: {
                  visible: false
                },
                waiting: {
                  visible: false
                }
              },
              instructions: $rootScope.translations.biometry[newLang]?.instructions || {},
              styling: {
                theme: {
                  colors: {
                    placeholderColor: "transparent"
                  }
                }
              }
            };
          }
        }
    });

    // Biometry on top functions
    $scope.biometryLoginRfs = function() {
      BiometryService.clearBiometryTimeout();
      BiometryService.setBiometryTimeout(function() {
          // Ak uplynie stanoveny cas a neprebehne prihlasenie
          BiometryService.setBiometryPause(true);
          $rootScope.biometryResolve({ state: "failed" });
          $rootScope.BottomScreen(AutoCaptureService.getAutoCaptureState() === AutoCaptureService.faceCaptureStates.biometry ? "biometryAutentification" : "biometryAutentificationPrivateAccess", { state: "failed", info: "timeout", timeStamp: Date.now(), initiator: "screensApp" });
          BiometryService.setBiometryCaptureCount(0);
          BiometryService.setBiometryLoginBtnTimeStamp(0);
      }, $rootScope.config.BiometryMaxFaceDetectionTime);
    };

    // Initial camera config when biometry login by face
    $scope.biometryLoadFaceProps = function(photoTakenCallBack) {
      try {
          var faceElement = document.querySelector("x-dot-face-auto-capture");
          if (faceElement) {
            faceElement.configuration = {
              onComplete: photoTakenCallBack,
              onError: function(err) {
                // Spustenie Camera Health Check servisu - kniznica zaznamenala chybu pri spracovani obrazu z kamery
                CameraHealthCheckService.start(document.querySelector('x-dot-face-auto-capture video'));
                // Log exception to console && kibana
                $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: biometryLoadFaceProps() { x-dot-face-auto-capture } error: ' + err);
                $rootScope.createLog(2, 'biometryLoadFaceProps() { x-dot-face-auto-capture }', '# ERROR: ' + err);
              },
              camera: {
                facingMode: $rootScope.config.BiometryFrontCamera
              },
              autoCapture: {
                candidateSelectionDurationMillis: AutoCaptureService.isOnboardingInProgress() ? $rootScope.config.BiometryOnboardingSelfieCandidateSelectionDuration : $rootScope.config.BiometryCandidateSelectionDuration
              },
              qualityAttributeThresholds: {
                confidence: {
                  min: $rootScope.config.BiometryFaceConfidence
                },
                sharpness: {
                  min: AutoCaptureService.isOnboardingInProgress() ? $rootScope.config.BiometryOnboardingSelfieSharpnessThreshold : $rootScope.config.BiometrySharpnessThreshold
                },
                brightness: {
                  min: $rootScope.config.BiometryBrightnessLowThreshold,
                  max: $rootScope.config.BiometryBrightnessHighThreshold
                },
                edgeDistanceToImageShorterSideRatio: {
                  min: $rootScope.config.BiometryOutOfBoundsThreshold
                },
                size: {
                  min: $rootScope.config.BiometryMinFaceSizeRatio,
                  max: $rootScope.config.BiometryMaxFaceSizeRatio
                },
                devicePitchAngle: {
                  max: $rootScope.config.BiometryDevicePitchAngleThreshold
                }
              }
            };
          }
          // First, send info to topScreen about ongoing login by biometry
          $rootScope.biometryResolve({ state: "continuing" });
      } catch (err) {
        // Log exception to console && kibana
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: biometryLoadFaceProps() error: ' + err);
        $rootScope.createLog(2, 'biometryLoadFaceProps()', '# ERROR: ' + err);
        return false;
      }
    };

    // Function for last checks before sending captured face to nativeApp when biometry login
    loginPlayerByFace = function (base64, imageTimeStamp, loginBtnTimeStamp) {
      return function() {
        try {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: loginPlayerByFace() { send foto } # imageTimeStamp: ' + imageTimeStamp + ' # loginBtnTimeStamp: ' + loginBtnTimeStamp);
          if ((imageTimeStamp - loginBtnTimeStamp) >= $rootScope.config.BiometryMaxFaceDetectionTime) {
            throw Error('(imageTimeStamp - loginBtnTimeStamp) >= BiometryMaxFaceDetectionTime, actual DateTime: ' + new Date().toString());
          }
          // Synchronous function without return value
          LoginPlayerByFace(base64, imageTimeStamp, loginBtnTimeStamp);
          // NativeApp will log in player if (NativeApp time - imageTimeStamp < MaxPhotoDelay)
          // MaxPhotoDelay = 5000 ms
          // Without nativeApp action if condition is not met
        } catch (err) {
          // Send biometry fail to Bottom Screen
          $rootScope.BottomScreen("biometryAutentification", { state: "failed", info: "loginPlayerByFace error", initiator: "screensApp" });
          // Log exception to console && kibana
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: loginPlayerByFace() # imageTimeStamp: ' + imageTimeStamp + ' # loginBtnTimeStamp: ' + loginBtnTimeStamp + ' error: ' + err.toString());
          $rootScope.createLog(2, 'loginPlayerByFace()', ' # imageTimeStamp: ' + imageTimeStamp + ' # loginBtnTimeStamp: ' + loginBtnTimeStamp + ' # ERROR: ' + err.toString());
        } finally {
          BiometryService.setBiometryLoginBtnTimeStamp(0);
        }
      }
    };

    // Function for last checks before sending captured selfie to nativeApp when onboarding last step
    onboardingSelfieSuccess = function (base64, imageTimeStamp) {
      return function() {
        try {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: onboardingSelfieSuccess() { send foto } # imageTimeStamp: ' + imageTimeStamp);
          // Synchronous function without return value
          OnboardingSelfieSuccess(base64, imageTimeStamp);
        } catch (err) {
          // Send biometry fail to Bottom Screen
          $rootScope.BottomScreen("biometryAutentification", { state: "failed", initiator: "screensApp" });
          // Log exception to console && kibana
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: onboardingSelfieSuccess() # imageTimeStamp: ' + imageTimeStamp + ' error: ' + err.toString());
          $rootScope.createLog(2, 'onboardingSelfieSuccess()', ' # imageTimeStamp: ' + imageTimeStamp + ' # ERROR: ' + err.toString());
        } finally {
          // Clean
          imageTimeStamp = 0;
          base64 = 0;
          BiometryService.setBiometryPause(false);
        }
      }
    };

    async function privateAccessPhotoTaken(imageData) {
      if (BiometryService.getBiometryPause()) {
          return false;
      }
      // Kontrola stavu kamery pred spracovanim odfotenej fotky
      if (!CameraHealthCheckService.isCameraHealthy()) return;
      var imageTimeStamp = Date.now();
      var base64 = await AutoCaptureService.blobToImage(imageData.image, AutoCaptureService.getAutoCaptureState(), true);

      if (AutoCaptureService.getAutoCaptureState() === AutoCaptureService.faceCaptureStates.privateAccess) {
        VerificationService.fetchBiometricVerificationStatusPrivate(base64, imageTimeStamp, BiometryService.getRequestorPlayerID())
        .promise.then(function(data) {
            try {
              if (data.isPlayerSelfieMatch) {
                // Overovana tvar patri prisluchajucemu playerID
                $rootScope.stopBiometry();
                $rootScope.visualState = "";
                $rootScope.settings.biometry.show = false;
                // Zobrazi hlasku o uspesnosti
                $rootScope.biometryResolve({ state: "success" });
                // Odosle informaciu o uspesnosti na spodnu obrazovku
                $rootScope.BottomScreen("biometryAutentificationPrivateAccess", { state: "success", requestorPlayerID: data.requestorPlayerID });
              } else {
                // Nerozpoznana tvar v suvislosti s playerID
                // Zobrazi hlasku o neuspesnosti
                $rootScope.biometryResolve({ state: "failed" });
                // Odosle informaciu o neuspespechu na spodnu obrazovku
                $rootScope.BottomScreen("biometryAutentificationPrivateAccess", { state: "failed", info: "isPlayerSelfieMatch = false" } );
              }
            } catch (e) {
              const stack = e instanceof Error ? e.stack : new Error().stack;
              // Odosle informaciu o neuspespechu na spodnu obrazovku
              $rootScope.BottomScreen("biometryAutentificationPrivateAccess", { state: "failed", info: "exception" } );
              // Odchytene vynimky - Zobrazi hlasku o neuspesnosti
              $rootScope.biometryResolve({ state: "failed" });
              // Zaloguje exception
              $rootScope.config.DebugJsConsoleLogEnabled && console.log("biometryAutentificationPrivateAccessException " + JSON.stringify({ state: "failed", info: "exception: " + stack }));
            }
        })
        .catch(function(err) {
            // Error na urovni komunikacie so serverom
            const stack = err instanceof Error ? err.stack : new Error().stack;
            if (err === 'canceled') {
              // Request bol zruseny (mohlo sa jednat o viacnasobny/dlho trvajuci request)
              $rootScope.biometryResolve({ state: "canceled" });
              $rootScope.BottomScreen("biometryAutentificationPrivateAccess", { state: "canceled", info: "request canceled: " + err } );
            } else {

              // Odosle informaciu o neuspespechu na spodnu obrazovku
              $rootScope.BottomScreen("biometryAutentificationPrivateAccess", { state: "failed", info: "communication error"} );
              // Zobrazi hlasku o neuspesnosti
              $rootScope.biometryResolve({ state: "failed" });
            }
            // Zaloguje exception
            $rootScope.config.DebugJsConsoleLogEnabled && console.log("biometryAutentificationPrivateAccessPromiseCatch " + JSON.stringify({ state: "failed", info: "communication error: " + stack }));
        })
      } else {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: privateAccessPhotoTaken() getAutoCaptureState(): ' + AutoCaptureService.getAutoCaptureState());
        $rootScope.createLog(2, 'privateAccessPhotoTaken()', '# imageTimeStamp: ' + imageTimeStamp + ' # getAutoCaptureState(): ' + AutoCaptureService.getAutoCaptureState());
      }
    }

    // Callback for login by biometry when face is captured
    async function biometryPhotoTaken(imageData) {
      if (BiometryService.getBiometryPause()) {
          return false;
      }
      // Kontrola stavu kamery pred spracovanim odfotenej fotky
      if (!CameraHealthCheckService.isCameraHealthy()) return;
      BiometryService.setBiometryPause(true);
      if (BiometryService.setBiometryCaptureCount(BiometryService.getBiometryCaptureCount() + 1) && BiometryService.getBiometryCaptureCount() <= $rootScope.config.BiometryBatchCount) {
          try {
            // Timestamp of face capture (windows local time). NativeApp uses windows local time too.
            var imageTimeStamp = Date.now();
            var base64 = await AutoCaptureService.blobToImage(imageData.image, AutoCaptureService.getAutoCaptureState(), false);

            if (AutoCaptureService.getAutoCaptureState() === AutoCaptureService.faceCaptureStates.biometry) {
              setTimeout(loginPlayerByFace(base64, imageTimeStamp, BiometryService.getBiometryLoginBtnTimeStamp()), 0);
            } else {
              $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: biometryPhotoTaken() getAutoCaptureState(): ' + AutoCaptureService.getAutoCaptureState());
              $rootScope.createLog(2, 'biometryPhotoTaken()', '# imageTimeStamp: ' + imageTimeStamp + ' # getAutoCaptureState(): ' + AutoCaptureService.getAutoCaptureState());
            }

          } catch (error) {
            // Log exception to console && kibana
            $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: biometryPhotoTaken() error: ' + error);
            $rootScope.createLog(2, 'biometryPhotoTaken()', '# imageTimeStamp: ' + imageTimeStamp + ' # loginBtnTimeStamp: ' + BiometryService.getBiometryLoginBtnTimeStamp() + ' # ERROR: ' + error.toString());
            BiometryService.setBiometryLoginBtnTimeStamp(0);
            return false;
          } finally {
            // Clean
            imageTimeStamp = 0;
            base64 = 0;
            if (BiometryService.getBiometryCaptureCount() < $rootScope.config.BiometryBatchCount) {
              // Biometry again
              BiometryService.setBiometryPause(false);
              document.dispatchEvent(
                new CustomEvent("face-auto-capture:control", {
                detail: { instruction: "continue-detection" }
                })
              );
            }
          }
      }
    };

    // Callback for onboarding when selfie is captured
    async function onboardingPhotoTaken(imageData) {
      // Kontrola stavu kamery pred spracovanim odfotenej fotky
      if (!CameraHealthCheckService.isCameraHealthy()) return;
      try {
        if (BiometryService.getBiometryPause()) {
          return false;
        }
        // Zastavenie animacie progressbaru a zobrazenie hlasky "Selfie sa odosiela..."
        $scope.setSelfieCaptured(true);
        BiometryService.setBiometryPause(true);
        // Timestamp of selfie capture (windows local time). NativeApp uses windows local time too.
        var imageTimeStamp = Date.now();
        var base64 = await AutoCaptureService.blobToImage(imageData.image, AutoCaptureService.getAutoCaptureState(), false);

        if (AutoCaptureService.getAutoCaptureState() === AutoCaptureService.faceCaptureStates.selfie) {
          setTimeout(onboardingSelfieSuccess(base64, imageTimeStamp), 0);
        } else {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: onboardingPhotoTaken() getAutoCaptureState(): ' + AutoCaptureService.getAutoCaptureState());
          $rootScope.createLog(2, 'onboardingPhotoTaken()', '# imageTimeStamp: ' + imageTimeStamp + ' # getAutoCaptureState(): ' + AutoCaptureService.getAutoCaptureState());
        }

      } catch (error) {
        // Log exception to console && kibana
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: onboardingPhotoTaken() error: ' + error);
        $rootScope.createLog(2, 'onboardingPhotoTaken()', '# imageTimeStamp: ' + imageTimeStamp + ' # ERROR: ' + error.toString());
        return false;
      } finally {
        // Clean
        imageTimeStamp = 0;
        base64 = 0;
        BiometryService.setBiometryPause(false);
      }
    };

    $scope.setSelfieCaptured = function(captured) {
      // https://www.figma.com/design/BBdutQNjj712a377WGSeso/DOXXbet-sportbox?node-id=4826-112071&t=AmxWbs5oQJYgfb6p-0
      if (captured) {
        // Zorbazi "Selfie sa odosiela..."
        $scope.selfieProgress = "photo_sending";
        // Vyplni progressbar na cely obvod
        $scope.strokeDasharrayValues = "";
      } else {
        // Skryje "Selfie sa odosiela..."
        $scope.selfieProgress = "";
        // Spusti animaciu progressbaru
        $scope.strokeDasharrayValues = AutoCaptureService.selfieProgressAnimationValues;
      }
      $rootScope.$$phase || $rootScope.$apply();
    }

    $rootScope.isOnboardingInProgress = function() {
      return AutoCaptureService.isOnboardingInProgress();
    }
  });
